import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import type { Filter } from 'mongodb';
import type { ChancenRole } from '../semantics/ChancenRole.js';

/**
 * @entity RoleFilter
 */
@Entity()
export class RoleFilter extends AdornisFilter {
  public static override _class = 'RoleFilter';

  constructor(doc: PartialEntityData<RoleFilter>) {
    super(doc);
  }

  // Only used to check if a filter has been changed to a new one
  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  public _id!: string;

  @Field(() => [String], {
    default: v => v ?? [],
  })
  public includesPermissions: Maybe<string[]>;

  override getMongoFilter() {
    const obj = this.toObject();
    const selector: Filter<ChancenRole> = {};
    if (obj.search) {
      selector.$or = [];
      selector.$or.push({
        name: { $regex: this._safeRegex(obj.search), $options: 'i' },
      });
      selector.$or.push({
        readableName: { $regex: this._safeRegex(obj.search), $options: 'i' },
      });
      selector.$or.push({
        aliases: { $regex: this._safeRegex(obj.search), $options: 'i' },
      });
    }

    return selector;
  }
}
